const recruiterScreenSummary = (
  <div className="internhub-summary">
    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Overview of Recruiter Phone Screens</h3>
      <ul className="list-disc pl-6">
        <li>Recruiter phone screens are an initial step in the hiring process.</li>
        <li>They help recruiters assess if you're a good fit for the role and company.</li>
        <li>These calls typically last 15-30 minutes and are mostly conversational.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Common Questions Recruiters Ask</h3>
      <ul className="list-disc pl-6">
        <li>Tell me about yourself and your background.</li>
        <li>Why are you interested in this role and company?</li>
        <li>What is your job search timeline?</li>
        <li>Are you interviewing with other companies?</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">How to Prepare</h3>
      <ul className="list-disc pl-6">
        <li>Practice a strong elevator pitch about your background and experience.</li>
        <li>Research the company and role beforehand.</li>
        <li>Find a quiet place with good reception for the call.</li>
        <li>Be ready to discuss your career goals and past work experiences.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Making a Great Impression</h3>
      <ul className="list-disc pl-6">
        <li>Speak clearly and confidently.</li>
        <li>Show enthusiasm for the role and company.</li>
        <li>Ask thoughtful questions about the team, role, and interview process.</li>
        <li>Send a follow-up thank-you email after the call.</li>
      </ul>
    </div>

    <div className="mb-4">
      <h3 className="text-lg font-semibold mb-2">Key Tips</h3>
      <ul className="list-disc pl-6">
        <li>Recruiter calls typically don’t include technical questions.</li>
        <li>
          If asked about other interviews, be strategic—mention them if they help create urgency.
        </li>
        <li>Keep your resume handy and take notes during the conversation.</li>
      </ul>
    </div>
  </div>
);

export default recruiterScreenSummary;
